import { createContext, useReducer } from 'react';
import reducer from './PagesReducer';

const initialState = {
    pages: [],
    showAddPageDialog: false,
    showEditPageDialog: false,
    showDeletePageDialog: false,
    showContextMenu: false,
    selectedPageIndex: "0_0",
    editPageIndex: null,
    deletePageIndex: null,
    contextMenuItemIndex: null,
    contextMenuOffset: null,
}

const PageContext = createContext(initialState);

export function PageContextProvider({ children }) {

    const [state, dispatch] = useReducer(reducer, initialState);

    return (
        <PageContext.Provider
            value={{
                state,
                dispatch
            }}
        >
            {children}
        </PageContext.Provider>
    )
}

export default PageContext;